<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>

<div>
    <section class="content-header row">
        <div class="col-md-12 box-header">
            <h2 class="box-title">
                <strong>Manage Vendor</strong>
            </h2>
            <div
                *ngIf="
                    user.role != 'Vendor Admin' && user.role != 'Vendor Coordinator' && !isInternalReadOnly && user.role != 'Coordinator'
                "
                class="pull-right box-tools"
            >
                <button
                    class="header-btn"
                    data-target="#vendorDetail"
                    data-toggle="modal"
                    title="Add Members"
                    type="submit"
                    (click)="openAddVendor()"
                >
                    <ds-icon name="add_circle" size="md" aria-hidden="true"></ds-icon>
                    <span class="padding-left-5">Vendor</span>
                </button>
            </div>
        </div>
    </section>
    <section class="content footerPosition">
        <div class="row">
            <div class="col-xs-12">
                <div class="card card-layout-tab">
                    <div *ngIf="user.role != 'Vendor Admin' && user.role != 'Vendor Coordinator'" class="card-layout card-margin">
                        <div>
                            <h4 class="filter-content-container row">Filter Options</h4>
                            <hr class="horizontal-line-style" />
                            <div class="row">
                                <div class="col-lg-3 col-md-3 col-sm-4">
                                    <label>Name</label>
                                    <ng-multiselect-dropdown-angular7
                                        id="select-vendor-name"
                                        placeholder="Vendor Name"
                                        [settings]="vendorDropdownSettings"
                                        [data]="vendorList$ | async"
                                        [(ngModel)]="selectedVendors"
                                    ></ng-multiselect-dropdown-angular7>
                                </div>
                                <div class="col-lg-2 col-md-3 col-sm-4">
                                    <label>Service Area</label>
                                    <ng-multiselect-dropdown-angular7
                                        id="select-service-area"
                                        [settings]="cityDataModel.cityDropdownSettings"
                                        [data]="cityDataModel.cityList"
                                        [placeholder]="'City'"
                                        [(ngModel)]="cityDataModel.selectedAreas"
                                    >
                                    </ng-multiselect-dropdown-angular7>
                                </div>
                                <div class="col-lg-2 col-md-3 col-sm-4">
                                    <label>Transport Type</label>
                                    <ng-multiselect-dropdown-angular7
                                        id="select-transport-type"
                                        [settings]="dropDownSettingsForTransportAndPriority"
                                        [data]="transportList"
                                        [placeholder]="'Type'"
                                        [(ngModel)]="selectedTransports"
                                    >
                                    </ng-multiselect-dropdown-angular7>
                                </div>
                                <div class="col-lg-2 col-md-3 col-sm-4">
                                    <label>Priority</label>
                                    <ng-multiselect-dropdown-angular7
                                        id="select-vendor-priority"
                                        [settings]="dropDownSettingsForTransportAndPriority"
                                        [data]="priorityList"
                                        [placeholder]="'Priority'"
                                        [(ngModel)]="selectedPriorities"
                                    >
                                    </ng-multiselect-dropdown-angular7>
                                </div>
                                <div class="col-md-3 col-lg-1 col-sm-4">
                                    <label class="text-color-white"> .</label>
                                    <button
                                        id="apply-filter"
                                        class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn font-size-14"
                                        type="submit"
                                        (click)="currentPage = 1; getVendorList()"
                                    >
                                        Apply
                                    </button>
                                </div>
                                <div class="col-md-3 col-lg-1 col-sm-4">
                                    <label class="text-color-white"> .</label>
                                    <button
                                        id="clear-filter"
                                        class="flat-butt flat-info-butt flat-info-grad-butt w-100 flat-danger-butt font-size-14 cursorPointer"
                                        type="button"
                                        (click)="cleanSearchedData()"
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row filter-section">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="col-xl-7 col-lg-6 col-md-6 col-sm-8 col-xs-8">
                                <span>Show</span>
                                <select
                                    id="select-entries"
                                    class="ml-2 custom-select custom-select-sm grid-header-element number-sort-filter"
                                    aria-controls="example1"
                                    name="example1_length"
                                    (change)="currentPage = 1; selectChange($event)"
                                >
                                    <option *ngFor="let number of numberOfEntries" [value]="number">
                                        {{ number }}
                                    </option>
                                </select>
                                <span class="ml-2">entries</span>
                            </div>
                            <div class="col-xl-1 col-lg-2 col-md-2 col-sm-4 col-xs-4">
                                <span
                                    id="show-all-btn"
                                    class="text-color text-color1 cursorPointer mt-2 pb-2 float-right"
                                    (click)="showAllVendor()"
                                >
                                    {{ dataFilter.isShowAllBusinessUnit ? 'Show Active' : 'Show All' }}
                                </span>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div id="example1_filter" class="d-flex float-right">
                                    <span>Search</span>
                                    <input
                                        id="search-filter"
                                        class="margin-left-7 form-control form-control-sm grid-header-element searchbar-element"
                                        aria-controls="example1"
                                        type="search"
                                        [(ngModel)]="searchText"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body-tab">
                        <div class="col-12 px-2">
                            <div class="cards-body">
                                <div class="tableSpacing">
                                    <div class="box-body">
                                        <table id="table" class="table card-layout table-striped table">
                                            <thead id="table-heading">
                                                <tr>
                                                    <td class="header_td table_heading">
                                                        <div class="header_container text-primary">
                                                            <div
                                                                id="vendor-name"
                                                                class="header_title cursorPointer"
                                                                (click)="sortBy = 'name'; sortOrder = !sortOrder; name = !name"
                                                            >
                                                                Name
                                                                <ds-icon
                                                                    *ngIf="name == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="name == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                id="service-area"
                                                                class="header_title cursorPointer"
                                                                (click)="
                                                                    sortBy = 'serviceArea.stateName';
                                                                    sortOrder = !sortOrder;
                                                                    stateName = !stateName
                                                                "
                                                            >
                                                                Service Area
                                                                <ds-icon
                                                                    *ngIf="stateName == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="stateName == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                id="address"
                                                                class="header_title cursorPointer"
                                                                (click)="
                                                                    sortBy = 'streetAddress';
                                                                    sortOrder = !sortOrder;
                                                                    streetAddress = !streetAddress
                                                                "
                                                            >
                                                                Address
                                                                <ds-icon
                                                                    *ngIf="streetAddress == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="streetAddress == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                id="phone-number"
                                                                class="header_title cursorPointer"
                                                                (click)="
                                                                    sortBy = 'phoneNumber';
                                                                    sortOrder = !sortOrder;
                                                                    phoneNumber = !phoneNumber
                                                                "
                                                            >
                                                                Phone
                                                                <ds-icon
                                                                    *ngIf="phoneNumber == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="phoneNumber == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                id="vendor-email"
                                                                class="header_title cursorPointer"
                                                                (click)="sortBy = 'emailID'; sortOrder = !sortOrder; emailID = !emailID"
                                                            >
                                                                Email
                                                                <ds-icon
                                                                    *ngIf="emailID == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="emailID == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                id="transport-type"
                                                                class="header_title cursorPointer"
                                                                (click)="
                                                                    sortBy = 'transportType';
                                                                    sortOrder = !sortOrder;
                                                                    transportType = !transportType
                                                                "
                                                            >
                                                                Transport Type
                                                                <ds-icon
                                                                    *ngIf="transportType == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="transportType == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                id="vendor-priority"
                                                                class="header_title cursorPointer"
                                                                (click)="sortBy = 'priority'; sortOrder = !sortOrder; priority = !priority"
                                                            >
                                                                Priority
                                                                <ds-icon
                                                                    *ngIf="priority == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="priority == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div
                                                                id="vendor-contracted"
                                                                class="header_title cursorPointer"
                                                                (click)="
                                                                    sortBy = 'isContracted';
                                                                    sortOrder = !sortOrder;
                                                                    isContracted = !isContracted
                                                                "
                                                            >
                                                                Is Contracted
                                                                <ds-icon
                                                                    *ngIf="isContracted == true"
                                                                    name="expand_less"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                                <ds-icon
                                                                    *ngIf="isContracted == false"
                                                                    name="expand_more"
                                                                    size="inherit"
                                                                    class="margin-left-7"
                                                                ></ds-icon>
                                                            </div>
                                                            <div *ngIf="user.role != 'Vendor Coordinator'" id="action" class="header_title">
                                                                Action
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody id="table-content">
                                                <tr
                                                    *ngFor="
                                                        let vendor of vendors
                                                            | orderBy: sortBy : sortOrder
                                                            | paginate
                                                                : {
                                                                      id: 'vendorPagination',
                                                                      itemsPerPage: selectedPage,
                                                                      currentPage: currentPage,
                                                                      totalItems: totalCount,
                                                                  };
                                                        let i = index
                                                    "
                                                >
                                                    <td>
                                                        <div class="row_container">
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Name</div>
                                                                <div class="row_detail break-word">
                                                                    <a
                                                                        *ngIf="!isInternalReadOnly"
                                                                        class="cursorPointer text-color"
                                                                        href="{{ baseUrl }}/common-details/vendor/{{
                                                                            vendor.businessUnitId
                                                                        }}"
                                                                    >
                                                                        {{ vendor.name }}
                                                                    </a>
                                                                    <span *ngIf="isInternalReadOnly">
                                                                        {{ vendor.name }}
                                                                    </span>
                                                                    <br />
                                                                    <span *ngIf="!vendor.status" class="badge on-time heading-font-size">
                                                                        Inactive
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Service Type</div>
                                                                <div
                                                                    *ngFor="let area of vendor?.serviceArea; let i = index"
                                                                    class="row_detail"
                                                                >
                                                                    <ng-template [ngIf]="i < 5">
                                                                        <div>
                                                                            <b>{{ area?.stateName }} ({{ area?.city.length }})</b>
                                                                            <b *ngIf="i == 4 && vendor?.serviceArea.length > 5">...</b>
                                                                        </div>
                                                                    </ng-template>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Address</div>
                                                                <div class="row_detail">
                                                                    {{ vendor?.streetAddress }} <br *ngIf="!!vendor?.streetAddress" />
                                                                    {{ vendor?.city }}, {{ vendor?.state }} {{ vendor.zipcode }}
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Phone</div>
                                                                <div class="row_detail">
                                                                    <a
                                                                        *ngIf="!isInternalReadOnly"
                                                                        class="phonenumberlink"
                                                                        href="tel:+1{{ vendor.phoneNumber }}"
                                                                    >
                                                                        {{ vendor.phoneNumber | phoneNumberPipe }}
                                                                    </a>
                                                                    <span *ngIf="isInternalReadOnly">
                                                                        {{ vendor.phoneNumber | phoneNumberPipe }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Email</div>
                                                                <div class="row_detail break-word">
                                                                    {{ vendor.emailID }}
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Transport Type</div>
                                                                <div class="row_detail">
                                                                    <span>{{ vendor.transportType }}</span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Priority</div>
                                                                <div class="row_detail">
                                                                    {{ vendor.priority }}
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="title_container"
                                                                [ngClass]="{ inactive_vendor: vendor.status == false }"
                                                            >
                                                                <div class="row_title">Is Contracted</div>
                                                                <div class="row_detail">
                                                                    {{ vendor.isContracted == true ? 'Yes' : 'No' }}
                                                                </div>
                                                            </div>
                                                            <div *ngIf="user.role != 'Vendor Coordinator'" class="title_container">
                                                                <div class="row_title">Action</div>
                                                                <div class="row_detail">
                                                                    <button
                                                                        *ngIf="user.role != 'Vendor Admin'"
                                                                        id="file-upload-btn"
                                                                        class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                                        title="Choose File/s"
                                                                        [disabled]="vendor.status == false"
                                                                        (click)="openUploadedFile(vendor.businessUnitId)"
                                                                    >
                                                                        <ds-icon name="upload" size="inherit"></ds-icon>
                                                                    </button>
                                                                    <div
                                                                        *ngIf="!isInternalReadOnly"
                                                                        class="dropdown"
                                                                        (click)="toggleMoreAction('moreAction', i + 1)"
                                                                    >
                                                                        <button
                                                                            id="more-option-btn"
                                                                            class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer ml-3"
                                                                            style="padding: 0.25rem 1.2rem !important"
                                                                            title="More"
                                                                            type="button"
                                                                        >
                                                                            <ds-icon name="more_vert" size="inherit"></ds-icon>
                                                                        </button>
                                                                        <div
                                                                            id="moreAction{{ i + 1 }}"
                                                                            class="dropdown-content more-container d-none"
                                                                        >
                                                                            <div
                                                                                *ngIf="
                                                                                    user.role != 'Vendor Admin' &&
                                                                                    user.role != 'Coordinator' &&
                                                                                    user.role != 'Management'
                                                                                "
                                                                                class="d-flex cursorPointer"
                                                                            >
                                                                                <div
                                                                                    class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer p-0 p-1 ml-2 mt-2"
                                                                                    [title]="
                                                                                        vendor.status ? 'Disable Vendor' : 'Enable Vendor'
                                                                                    "
                                                                                >
                                                                                    <div
                                                                                        class="checkbox checkbox-switch switch-danger my-0"
                                                                                    >
                                                                                        <label>
                                                                                            <input
                                                                                                id="enable-disable-vendor-btn"
                                                                                                type="checkbox"
                                                                                                [checked]="vendor.status"
                                                                                                (change)="changeToggle($event, vendor)"
                                                                                            />
                                                                                            <span></span>
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                                <span *ngIf="vendor.status" class="more-icon-text pl-2">
                                                                                    Disable Vendor
                                                                                </span>
                                                                                <span *ngIf="!vendor.status" class="more-icon-text pl-2">
                                                                                    Enable Vendor
                                                                                </span>
                                                                            </div>
                                                                            <div
                                                                                id="edit-vendor-div"
                                                                                class="d-flex cursorPointer"
                                                                                [class.disabled-div]="!vendor.status"
                                                                                data-target="#vendorDetail"
                                                                                data-toggle="modal"
                                                                                title="Edit Vendor"
                                                                                (click)="openEditVendorModel(vendor)"
                                                                            >
                                                                                <button
                                                                                    class="dropdown_padding flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                                                >
                                                                                    <ds-icon name="edit_square" size="inherit"></ds-icon>
                                                                                </button>
                                                                                <span class="more-icon-text cursorPointer"
                                                                                    >Edit Vendor</span
                                                                                >
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div *ngIf="vendors.length == 0" class="text-color mt-2">
                                            <b>No Record Found</b>
                                        </div>
                                        <div *ngIf="vendors.length > 0" class="col-md-12 p-0 mt-3">
                                            <div class="col-md-6 p-0">
                                                {{ pagination }}
                                            </div>
                                            <div class="col-md-6 pagination text-end mt-1">
                                                <pagination-controls
                                                    id="vendorPagination"
                                                    [maxSize]="6"
                                                    [nextLabel]="''"
                                                    [previousLabel]="''"
                                                    [responsive]="responsive"
                                                    (pageChange)="currentPage = $event; currentPageChange()"
                                                ></pagination-controls>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<!--Add/Edit vendor-->
<app-editVendor
    [chooseFile]="chooseFile"
    [detail]="vendorDetail"
    [isModelOpen]="isModelOpen"
    [isVehicleCreated]="isVehicleCreated"
    [modalHeader]="modalHeader"
    [selectedIndex]="+selectedIndex"
    (closeModel)="modelClose()"
    (valueChange)="getVendorList()"
    (vendorListNames)="updateVendorList()"
>
</app-editVendor>
